import get from 'lodash/get'

class Environment {
  constructor(path) {
    this.path = path
  }

  callFunction(funcName, args, noDestructure) {
    const path = this.path + '.' + funcName

    const func = get(window, path, null)

    if (func && typeof (func) === 'function') {

      // don't break down args into values. Useful for passing arrays rather than objects
      if (noDestructure) {
        return func(args || null)
      }
      if (args === undefined) {
        return func(null)
      }
      return func(...args || null)
    }

    return null
  }

  checkFunction(funcName) {
    const path = this.path + '.' + funcName

    return get(window, path)
  }
}

export default Environment

/*
export function checkFunction(path) {
 return get(path);
}

export function callFunction(path, arguments) {
  const func = get(window, path, null);

  if(func && typeof(func) === 'function') {
    return func.apply(null, arguments);
  }
} */

/* export function checkFunction(funcRef) {
  return (window.TR_pageFunctions && window.TR_pageFunctions[funcRef] && typeof window.TR_pageFunctions[funcRef] === 'function')
} */
